var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid place-items-center w-full"},[_c('div',{},[_c('child')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }